module.exports = __webpack_public_path__ + "static/media/sedeestrellaroja.91a77f72.webp";